import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Alert,
  Spinner,
} from "reactstrap";
import axios from "axios";
import { showToast } from "../../../utils/toast";

const API_URL = process.env.REACT_APP_API_URL;

/* =========================
   STATUS OPTIONS
========================= */
const STATUS_OPTIONS = [
  { label: "Pending", value: "PENDING" },
  //   { label: "Agreement Uploaded", value: "AGREEMENT_UPLOADED" },
  { label: "Active", value: "ACTIVATE" },
  { label: "DeActive", value: "DEACTIVATE" },
  { label: "Inactive", value: "INACTIVE" },
  { label: "Suspended", value: "SUSPENDED" },
  { label: "Rejected", value: "REJECTED" },
];

const OrganizationStatusModal = ({
  isOpen,
  toggle,
  organization,
  onSuccess,
}) => {
  /* =========================
     STATE
  ========================= */
  const [action, setAction] = useState("");
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* =========================
     RESET ON OPEN
  ========================= */
  useEffect(() => {
    if (isOpen && organization) {
      setAction("");
      setReason("");
      setError("");
    }
  }, [isOpen, organization]);

  /* =========================
     SUBMIT HANDLER
  ========================= */
  const handleSubmit = async () => {
    if (!action) {
      setError("Please select a status");
      return;
    }

    if (!reason.trim()) {
      setError("Please provide a reason");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const token = sessionStorage.getItem("token") || localStorage.getItem("token");

      await axios.patch(
        `${API_URL}/superadmin/organizations/${organization.id}/status`,
        {
          action,
          reason,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      showToast("Organization status updated successfully", "success");

      toggle();
      onSuccess?.();
    } catch (err) {
      setError(err?.response?.data?.message || "Failed to update status");
    } finally {
      setLoading(false);
    }
  };

  if (!organization) return null;

  /* =========================
     RENDER
  ========================= */
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Update Organization Status</ModalHeader>

      <ModalBody>
        <Form>
          {/* Organization Name */}
          <FormGroup>
            <Label>Organization</Label>
            <Input value={organization.organizationName} disabled />
          </FormGroup>

          {/* Status Dropdown */}
          <FormGroup>
            <Label>Status *</Label>
            <Input
              type="select"
              value={action}
              onChange={(e) => setAction(e.target.value)}
            >
              <option value="">Select Status</option>
              {STATUS_OPTIONS.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </Input>
          </FormGroup>

          {/* Reason */}
          <FormGroup>
            <Label>Reason *</Label>
            <Input
              type="textarea"
              rows={3}
              placeholder="Enter reason for status change"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </FormGroup>

          {error && <Alert color="danger">{error}</Alert>}
        </Form>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>

        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? <Spinner size="sm" /> : "Update Status"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrganizationStatusModal;

